// extracted by mini-css-extract-plugin
export default {"label":"toggle_label__HNzVV","toggleInput":"toggle_toggleInput__5w5mF","toggle":"toggle_toggle__sOauI"};